export const LPG_PRODUCT_ID = '4588b5e6-7309-49d0-9107-59cbb96b6bd8';
export const GASOLINE_PRODUCT_ID = '4588b5e6-7309-49d0-9107-59cbb96b6bd7';

export const LPG_CARGO_RATIO_PRODUCT_TYPE_IDS = [
  '4588b5e6-7309-49d0-9107-59cbb96b6b18',
  '4588b5e6-7309-49d0-9107-59cbb96b6b19',
];

export const isLpgProductId = productNameId => productNameId === LPG_PRODUCT_ID;

export const isGasolineProductId = productNameId =>
  productNameId === GASOLINE_PRODUCT_ID;

export const usesDyedUndyedAlpha = productNameId =>
  isGasolineProductId(productNameId);

export const getAlphaColumnLabel = pricingUnit =>
  pricingUnit ? `Alpha (${pricingUnit})` : 'Alpha';

export const getProcurementProductNameId = procurement =>
  procurement?.productType?.product?.id ??
  procurement?.productType?.product?.Id ??
  procurement?.productType?.Product?.id ??
  procurement?.productType?.Product?.Id ??
  null;

export const getProcurementProductTypeId = procurement =>
  procurement?.productType?.id ?? procurement?.productType?.Id ?? null;

export const isLpgProcurement = procurement =>
  isLpgProductId(getProcurementProductNameId(procurement));

export const isLpgProduct = isLpgProcurement;

export const requiresLpgCargoRatio = form => {
  if (!isLpgProductId(form?.productNameId)) return false;
  const productTypeId =
    form?.productTypeId ?? form?.productType?.id ?? form?.productType?.Id;
  return LPG_CARGO_RATIO_PRODUCT_TYPE_IDS.includes(String(productTypeId));
};

export const requiresLpgCargoRatioSelection = procurement =>
  requiresLpgCargoRatio({
    productNameId: getProcurementProductNameId(procurement),
    productTypeId: getProcurementProductTypeId(procurement),
  });
